// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-4de74d94]{font-size:1.05rem}", ""]);
// Exports
module.exports = exports;
